import type {
  UseGetVendorsQuoteStatusParams,
  UseGetVendorsQuoteStatusQueryKey,
} from './types';

export const getUseGetVendorsQuoteStatusQueryKey = (
  params: UseGetVendorsQuoteStatusParams,
): UseGetVendorsQuoteStatusQueryKey => [
  'vendors',
  'vendorsQuoteStatus',
  params,
];
